<template>
    <div class="surveys">
        <account-tabs v-model="currentTab" :tabs="tabs" />

        <div class="content">
            <div class="list" v-loading="isDataLoading">

                <div v-if="filterSurveys(currentTab).length">
                    <div
                        class="card"
                        :class="currentTab"
                        v-for="item in filterSurveys(currentTab)"
                        :key="item.id"
                        @click="startSurveyHandler(item)"
                    >
                        <div class="header">
                            <div class="title">{{ item.name }}</div>
                            <div class="status"></div>
                        </div>

                        <div class="till">
                            Заполните анкету до {{ formatDate(item.dateEnd) }}
                        </div>

                        <div class="field">
                            <span class="label">Программа:</span>
                            <div class="value">{{ item.program }}</div>
                        </div>

                        <div class="field">
                            <span class="label">Цель опроса:</span>
                            <div class="value">{{ item.purpose }}</div>
                        </div>
                    </div>
                </div>
                <div v-else class="empty">
                    Опросов пока нет
                </div>
            </div>
            <!-- <Button
                v-if="getSurveysCount && getSurveysCount > surveys.length"
                class="more_btn"
                @click="loadMoreHandler"
            >Показать еще</Button> -->
        </div>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';

// import Button from '@/components/UI/Button';
import AccountTabs from '@/components/UI/AccountTabs';

const surveysActions = ['fetchSurveys'];

const surveysGetters = ['getSurveys', 'getSurveysCount'];

const examMutations = ['setSessionType', 'setSingleSession'];

export default {
    name: 'Surveys',
    components: {
        // Button,
        AccountTabs,
    },
    data: () => ({
        isDataLoading: false,
        currentTab: 'active',
        // page: 1,
        // limit: 6,
        statuses: {
            active: ['new', 'in_progress'],
            missed: ['aborted'],
            completed: ['completed', 'need_help', 'need_check', 'in_check'],
        },
    }),
    computed: {
        tabs() {
            return [
                {
                    label: 'Активные',
                    key: 'active',
                    color: 'blue',
                    count: this.filterSurveys('active').length,
                },
                {
                    label: 'Пропущенные',
                    key: 'missed',
                    color: 'red',
                    count: this.filterSurveys('missed').length,
                },
                {
                    label: 'Завершенные',
                    key: 'completed',
                    color: 'grey',
                    count: this.filterSurveys('completed').length,
                },
            ];
        },
        ...mapGetters('mentoring/surveys', surveysGetters),
    },
    async created() {
        await this.loadSurveys();
    },
    methods: {
        async loadSurveys() {
            this.isDataLoading = true;
            await this.fetchSurveys();
            this.isDataLoading = false;
        },
        startSurveyHandler(item) {
            this.setSessionType('survey');
            this.setSingleSession(false);
            this.$router.push({
                name: 'start-session',
                params: {
                    id: item.foreignId,
                },
            });
        },
        filterSurveys(key) {
            return this.getSurveys.filter(
                item => this.statuses[key].indexOf(item.status) > -1
            );
        },
        formatDate(src) {
            const d = src.slice(8, 10);
            const m = src.slice(5, 7);
            const y = src.slice(0, 4);

            return `${d}.${m}.${y}`;
        },
        ...mapActions('mentoring/surveys', surveysActions),
        ...mapMutations('exam', examMutations),
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/rem';
@import '@/styles/mrem';

.surveys {
    .content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .list {
            position: relative;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-bottom: rem(8);
            width: 100%;
            @include on-mobile {
                flex-direction: column;
                align-items: stretch;
            }
            .preloader {
                position: absolute;
                z-index: 999;
                background-color: rgba(255, 255, 255, 0.9);
            }
            .card {
                display: flex;
                flex-direction: column;
                align-items: stretch;
                width: rem(333);
                overflow: hidden;
                border: rem(1) solid;
                border-radius: rem(4);
                margin-bottom: rem(24);
                padding: rem(16);
                user-select: none;
                cursor: pointer;
                text-decoration: none;
                @include on-mobile {
                    width: 100%;
                    border-radius: mrem(4);
                    margin-bottom: mrem(24);
                }

                .header {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: rem(4);
                    .title {
                        font-weight: 600;
                        font-size: rem(16);
                        line-height: rem(24);
                        color: #000000;
                        max-width: rem(260);
                        max-height: rem(48);
                        overflow: hidden;
                    }
                    .status {
                        width: rem(24);
                        height: rem(24);
                        border-radius: rem(24);
                        background-color: #000000;
                        opacity: 0.38;
                    }
                }

                .till {
                    font-weight: 600;
                    font-size: rem(14);
                    line-height: rem(20);
                    color: #000000;
                }

                .field {
                    display: flex;
                    flex-direction: column;
                    align-items: stretch;
                    margin-top: rem(16);
                    .label {
                        font-weight: 600;
                        font-size: rem(14);
                        line-height: rem(20);
                        color: #98a0a9;
                        margin-bottom: rem(4);
                    }
                    .value {
                        font-size: rem(14);
                        line-height: rem(20);
                        color: #000000;
                        max-height: rem(60);
                        overflow: hidden;
                    }
                }
                &.active {
                    border-color: #1184ed;

                    .header {
                        .title {
                            color: #1184ed;
                        }
                        .status {
                            background-color: #1184ed;
                        }
                    }

                    .till {
                        color: #1184ed;
                    }
                }
                &.missed {
                    border-color: #ef627d;

                    .header {
                        .title {
                            color: #ef627d;
                        }
                        .status {
                            background-color: #ef627d;
                        }
                    }

                    .till {
                        color: #ef627d;
                    }
                }
                &.completed {
                    border-color: #575757;

                    .header {
                        .title {
                            color: #575757;
                        }
                        .status {
                            background-color: #575757;
                        }
                    }

                    .till {
                        color: #575757;
                    }
                }
            }
        }
        .more_btn {
            padding: 0 rem(32);
            @include on-mobile {
                padding: auto;
                width: 100%;
            }
        }
    }
}

.empty {
    width: 100%;
    display: flex;
    align-items: center;
    color: #98a0a9;
    font-size: rem(15);
    line-height: rem(22);
    font-weight: 600;
    justify-content: center;
}
</style>
